module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ThinItalic-d8e2db7d98e7618f405dc487d4565571.otf";